<script>
import getSecret from "@utils/get-secret";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import BaseDatatable from "@components/base-datatable";
import ThirdpartyMultiselect from "@components/euro_coupons/thirdparty/Select";
import UserMultiselect from "@components/roles_management/users/Select.vue";
import CustomDatePickerRange from "@components/CustomDatePickerRange";
import { euroCouponsTutorialMethods } from "@state/helpers";

import { euroCouponsRequestCouponMethods, authComputed } from "@state/helpers";

export default {
  name: "EuroCouponsRequestCouponIndex",
  page: {
    title: "Solicitud de Bonos",
    meta: [{ name: "description", content: getSecret("DESCRIPTION") }],
  },
  components: {
    Layout,
    PageHeader,
    BaseDatatable,
    ThirdpartyMultiselect,
    CustomDatePickerRange,
    UserMultiselect,
    EuroCouponsRequestCouponForm: () =>
      import("@components/euro_coupons/request_coupon/Form"),
    EuroCouponsRequestCouponUploadData: () =>
      import("@components/euro_coupons/request_coupon/UploadData"),
    EuroCouponsRequestCouponUploadDataInternal: () =>
      import("@components/euro_coupons/request_coupon/UploadDataInternal"),
    EuroCouponsRequestCouponDetail: () =>
      import("@components/euro_coupons/request_coupon/Detail"),
    EuroCouponsRequestCouponDelete: () =>
      import("@components/euro_coupons/request_coupon/Delete"),
  },
  data() {
    return {
      title: this.$t("requests_coupons"),
      items: [
        {
          text: this.$t("home"),
          href: "/",
        },
        {
          text: this.$t("requests_coupons"),
          active: true,
        },
      ],
      loadingReport: false,
      sending: false,
      tableHeaders: [],
      autogenerate: false,
      internal: false,
      is_thirdparty_user: false,
      toUpdate: {},
      toDetail: {},
      toDelete: {},
      showForm: false,
      showDetail: false,
      showDelete: false,
      filterset: null,
      restartRange: false,
      filters: {
        thirdparty: null,
        requesting_user__in: null,
        request_date__gte: null,
        request_date__lte: null,
      },
      type_action: null,
    };
  },

  mounted() {
    const _ = this;
    let user_info = _.currentSession.user.user_info;
    _.autogenerate = user_info.thirdparty_info
      ? user_info.thirdparty_info.autogenerate_coupons
      : false;
    _.internal = user_info.thirdparty_info ? user_info.thirdparty_info.internal : false;
    this.setShowTutorial(true);
    _.autogenerate
      ? this.setTutorialUrl("solicitudes_juju")
      : this.setTutorialUrl("solicitudes");

    _.is_thirdparty_user = user_info.is_thirdparty_user;

    if (_.is_thirdparty_user) {
      _.filters.thirdparty = user_info.thirdparty_info.id;
    }

    this.tableHeaders = [
      { key: "requesting_user", label: this.$t("requesting_user") },
      {
        key: "quantity",
        label: this.$t("quantity"),
        formatter: (value) => {
          return this.$formatDollar(value);
        },
      },
      {
        key: "value",
        label: this.$t("value"),
        formatter: (value) => {
          return this.$formatDollar(value);
        },
      },
    ];
    if (this.autogenerate || !this.is_thirdparty_user) {
      this.tableHeaders = [
        ...this.tableHeaders,
        ...[{ key: "purchase_order", label: this.$t("purchase_order") }],
      ];
    }

    this.tableHeaders = [
      ...this.tableHeaders,
      ...[
        { key: "request_date", label: this.$t("request_date") },
        { key: "actions", label: this.$t("actions") },
      ],
    ];
  },

  computed: {
    ...authComputed,
  },

  beforeMount() {},

  watch: {
    filters: {
      deep: true,
      handler(filters) {
        let filters_list = [];
        for (let filter in filters) {
          if (filters[filter]) {
            filters_list.push(`${filter}=${filters[filter]}`);
          }
        }
        if (filters_list.length) {
          this.filterset = filters_list.join("&");
        }
        this.filter();
      },
    },
  },

  destroyed() {
    this.setShowTutorial(false);
  },

  methods: {
    // ...authComputed,
    ...euroCouponsRequestCouponMethods,
    ...euroCouponsTutorialMethods,
    myProvider(ctx) {
      let context = this;

      ctx = context.$table_params(ctx);
      ctx += context.filterset ? `&${context.filterset}` : "";
      const promise = context.fetchEuroCouponsRequestCoupon(ctx);
      return promise
        .then((data) => {
          return data;
        })
        .catch((error) => {
          context.$axios_error_noty(error, context);
          console.log(error);
          return [];
        });
    },

    setFilter(filter, value) {
      this.filters[filter] = value;
    },

    filter() {
      this.$refs.table.lastFilter = "";
      this.$refs.table.onFiltered();
      setTimeout(() => this.$refs.table.refresh(), 200);
    },

    clear() {
      let context = this;
      this.filters.requesting_user__in = null;
      this.filters.request_date__gte = null;
      this.filters.request_date__lte = null;

      if (context.is_thirdparty_user === false) {
        context.filters.thirdparty = null;
      }
      this.filterset = null;
      setTimeout(() => this.$refs.table.refresh(), 200);
    },

    getGeneralReport() {
      let _ = this;
      _.loadingReport = true;
      let query = _.filterset ? `?${_.filterset}` : "";
      const promise = _.fetchDownloadReport({
        query: query,
        type: { responseType: "arraybuffer" },
      });
      return promise
        .then((response) => {
          const data = response.data;
          const url = URL.createObjectURL(
            new Blob([data], {
              type: "application/vnd.ms-excel",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Solicitudes de Bonos.xlsx`);
          document.body.appendChild(link);
          link.click();
          _.loadingReport = false;
        })
        .catch((error) => {
          _.loadingReport = false;
          console.error(error);
          _.$axios_error_noty("Se presento un error en la descarga del archivo.");
        });
    },

    sendGeneralReport() {
      let context = this;
      context.sending = true;
      let query = context.filterset ? `?${context.filterset}` : "";
      const promise = context.sendGeneralReportRequestCoupon({ query });
      return promise
        .then((data) => {
          context.$generate_toast(
            context,
            "success",
            `${context.$t("request_coupon")} ${context.$t("sent")} ${context.$t(
              "correctly"
            )}`
          );
          context.sending = false;
        })
        .catch((error) => {
          context.$axios_error_noty(error, context);
          context.sending = false;
        });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-container fluid>
      <b-row>
        <b-col>
          <b-card class="shadow-sm">
            <b-row class="text-primary px-2 mb-2" style="font-size: 16px">
              <b>{{ $t("filters") }}</b>
            </b-row>
            <b-row>
              <b-col md="3" v-if="!is_thirdparty_user">
                <ThirdpartyMultiselect
                  :value="filters.thirdparty"
                  @input="
                    (value) => {
                      setFilter('thirdparty', value);
                      setFilter('requesting_user__in', null);
                    }
                  "
                ></ThirdpartyMultiselect>
              </b-col>
              <b-col md="3">
                <UserMultiselect
                  :value="filters.requesting_user__in"
                  :thirdpartyId="filters.thirdparty"
                  :disabled="filters.thirdparty ? false : true"
                  @input="(value) => setFilter('requesting_user__in', value)"
                ></UserMultiselect>
              </b-col>
              <b-col md="4" class="p-0">
                <b-col
                  ><CustomDatePickerRange
                    :label="'request_date'"
                    :value_start="filters.request_date__gte"
                    :value_end="filters.request_date__lte"
                    @input_start="(value) => setFilter('request_date__gte', value)"
                    @input_end="(value) => setFilter('request_date__lte', value)"
                /></b-col>
              </b-col>
              <b-col md="2" class="ml-auto pt-3 pr-1 mt-1">
                <!-- <b-button
                  class="ml-1 rounded shadow-sm float-right"
                  variant="outline-primary"
                  @click="filter"
                  ><i class="fas fa-filter"></i>
                </b-button> -->
                <b-button
                  class="rounded shadow-sm float-right"
                  variant="outline-primary"
                  @click="clear"
                  ><i class="fas fa-eraser"></i>
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card class="shadow">
            <BaseDatatable
              ref="table"
              :drfprovider="myProvider"
              :tableheaders="tableHeaders"
            >
              <template v-slot:buttons>
                <b-button
                  v-if="is_thirdparty_user"
                  variant="outline-primary rounded-lg pt-1 mx-2"
                  size="sm"
                  @click="
                    () => {
                      showForm = true;
                      toUpdate = {};
                      type_action = 'create';
                    }
                  "
                >
                  <!-- <i class="fe-plus" style="font-size:18px"></i> -->
                  <i class="fas fa-plus"></i>
                </b-button>
                <b-button
                  v-if="is_thirdparty_user"
                  variant="outline-primary rounded-lg pt-1"
                  size="sm"
                  @click="
                    () => {
                      showForm = true;
                      toUpdate = {};
                      type_action = 'delete';
                    }
                  "
                >
                  <!-- <i class="fe-plus" style="font-size:18px"></i> -->
                  <i class="fas fa-trash"></i>
                </b-button>
                <b-button
                  variant="outline-primary rounded-lg  mx-1"
                  :disabled="loadingReport"
                  @click="getGeneralReport"
                >
                  <b-spinner v-if="loadingReport" small label="Spinning"></b-spinner>
                  <i v-else class="fas fa-download"></i>
                </b-button>
                <b-button
                  variant="outline-primary rounded-lg"
                  v-if="is_thirdparty_user"
                  :disabled="sending"
                  @click="sendGeneralReport"
                >
                  <b-spinner v-if="sending" small label="Spinning"></b-spinner>
                  <i v-else class="far fa-paper-plane"></i>
                </b-button>
              </template>
              <template v-slot:cell(requesting_user)="row">
                <b-row>
                  <b-col cols="2" class="p-0">
                    <b-avatar
                      size="54px"
                      class="border border-primary"
                      :src="row.item.user_detail ? row.item.user_detail.photo : ''"
                    ></b-avatar>
                  </b-col>
                  <b-col class="d-flex flex-column justify-content-center">
                    <p class="p-0 m-0 font-weight-bold">
                      {{ row.item.user_detail ? row.item.user_detail.username : "-" }}
                    </p>
                    <i class="p-0 m-0">{{
                      row.item.user_detail ? row.item.user_detail.thirdparty_name : "-"
                    }}</i>
                  </b-col>
                </b-row>
              </template>
              <template v-slot:cell(actions)="row">
                <b-button-group size="xs">
                  <b-button
                    :id="`info-btn-${row.index}`"
                    v-b-tooltip.hover="{
                      variant: 'info',
                      placement: 'leftbottom',
                      title: $t('detail'),
                    }"
                    variant="btn-link text-info btn-transparent"
                    size="xs"
                    @click="
                      () => {
                        showDetail = true;
                        toDetail = row.item;
                      }
                    "
                  >
                    <i class="fe-info fe-2x"></i>
                  </b-button>
                  <!-- 
                  <b-button
                    :id="`update-btn-${row.index}`"
                    v-b-tooltip.hover="{
                      variant: 'warning',
                      placement: 'leftbottom',
                      title: $t('edit'),
                    }"
                    variant="btn-link text-warning btn-transparent"
                    size="xs"
                    @click="()=>{showForm=true; toUpdate=row.item}"
                  >
                    <i class="fe-edit fe-2x"></i>
                  </b-button>

                  <b-button
                    :id="`delete-btn-${row.index}`"
                    v-b-tooltip.hover="{
                      variant: 'danger',
                      placement: 'leftbottom',
                      title: $t('delete'),
                    }"
                    variant="btn-link text-danger btn-transparent"
                    size="xs"
                    @click="()=>{showDelete=true; toDelete=row.item}"
                  >
                    <i class="fe-x fe-2x"></i>
                  </b-button> -->
                </b-button-group>
              </template>
            </BaseDatatable>
          </b-card>
        </b-col>
      </b-row>
    </b-container>

    <!-- Detail modal -->
    <EuroCouponsRequestCouponDetail
      v-if="showDetail"
      :instanceJson="toDetail || {}"
      :deleteAction="is_thirdparty_user"
      :oncomplete="
        () => {
          showDetail = false;
          toDetail = {};
        }
      "
      :oncancel="
        () => {
          showDetail = false;
          toDetail = {};
        }
      "
    >
    </EuroCouponsRequestCouponDetail>

    <EuroCouponsRequestCouponForm
      v-if="showForm && autogenerate && !internal"
      :fullform="true"
      :instanceJson="toUpdate || {}"
      :oncomplete="
        () => {
          showForm = false;
          toUpdate = {};
          $refs.table.refresh();
        }
      "
      :oncancel="
        () => {
          showForm = false;
          toUpdate = {};
        }
      "
    >
    </EuroCouponsRequestCouponForm>

    <EuroCouponsRequestCouponUploadData
      v-if="showForm && !autogenerate && !internal"
      :fullform="true"
      :instanceJson="toUpdate || {}"
      :oncomplete="
        () => {
          showForm = false;
          toUpdate = {};
          $refs.table.refresh();
        }
      "
      :oncancel="
        () => {
          showForm = false;
          toUpdate = {};
        }
      "
    >
    </EuroCouponsRequestCouponUploadData>
    <EuroCouponsRequestCouponUploadDataInternal
      v-if="showForm && internal"
      :fullform="true"
      :instanceJson="toUpdate || {}"
      :oncomplete="
        () => {
          showForm = false;
          toUpdate = {};
          $refs.table.refresh();
        }
      "
      :type_action="type_action"
      :oncancel="
        () => {
          showForm = false;
          toUpdate = {};
        }
      "
    >
    </EuroCouponsRequestCouponUploadDataInternal>
    <!-- <EuroCouponsRequestCouponDelete
      v-if="showDelete"
      :instanceJson="toDelete"
      :oncomplete="
        () => {
          showDelete = false;
          toDelete = {};
          $refs.table.refresh()
        }
      "
      :oncancel="
        () => {
          showDelete = false;
          toDelete = {}
        }
      "
    >
    </EuroCouponsRequestCouponDelete> -->
  </Layout>
</template>
